// extracted by mini-css-extract-plugin
export default {"wrapper":"InputText_wrapper__fg71q","error":"InputText_error__hoi4f","input":"InputText_input__Oo2Gz","label":"InputText_label__vK+d+","maxLength":"InputText_maxLength__yVw0M"};